<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn st-button-excel rounded-pill">
  <i class="bi bi-filetype-xls"></i>
    {{label}}
</button>
